<section class="hero" aria-labelledby="hero-title">
  <header class="hero__brand">
     <img class="hero__logo" [src]="companyLogoUrl" alt="Loba Cria — Soluções em Marketing" />
  </header>

  <div class="hero__main">
    <div class="hero__media" aria-hidden="true">
      <div class="hero__media-frame">
        <div class="hero__media-glow"></div>
        <img
          class="hero__media-visual"
          src="assets/hero.png"
          alt=""
          aria-hidden="true"
        />
  
        <div class="hero__media-overlay"></div>
      </div>
    </div>

    <div class="hero__content">
      <p class="hero__eyebrow">Coberturas Loba Cria</p>
      <h1 id="hero-title" class="hero__title">
        Os registros dessa <span class="hero__title-accent">cobertura</span> já estão disponíveis
      </h1>
      <p class="hero__subtitle">
        Conteúdos produzidos em tempo real para manter o evento vivo também nas redes sociais.
      </p>
      <app-pill-button label="Acessar cobertura" variant="gold" href="#eventos" />
    </div>
  </div>
</section>
